import React, {useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {TextInput} from "Ficha/components/TextInput";
import Button from "components/CustomButtons/Button.js";
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
import { useForm } from 'react-hook-form'
import { enviarMsg } from 'firebase/firestoreData'

const styles = {
  root:{
    margin: '0 auto',
  },
  field:{
    margin: 10,
    maxWidth: '400px'
  },
  sendBtn: {
    maxWidth: 400,
    margin: '20px 40px 40px 20px'
  }
};

const useStyles = makeStyles(styles);

export default function ContactForm() {
  const classes = useStyles();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const { register, handleSubmit } = useForm()

  function handleCloseMessage() {
    setShowSuccessMessage(false)
  }

  const onSubmit = data => {
    enviarMsg(data)
    setShowSuccessMessage(true)
  };

  return (
    <div className={classes.root}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <TextInput label="Nome" name="nome" className={classes.field} InputLabelProps={{shrink: true}} ref={register} required/>
            <TextInput label="Email" name="email" className={classes.field} InputLabelProps={{shrink: true}} ref={register} required/>
            <TextInput label="Telefone" name="telefone" className={classes.field} InputLabelProps={{shrink: true}} ref={register} required/>
            <TextInput label="Mensagem" name="mensagem" multiline placeholder="Pressione Enter para adicionar linhas" className={classes.field} InputLabelProps={{shrink: true}} ref={register} required/>
            <Button className={classes.sendBtn} type="submit" color="primary">ENVIAR</Button>
          </form>
          <CustomSnackbar open={showSuccessMessage} onClose={handleCloseMessage} message={"Mensagem enviada com sucesso"}/>
        </GridItem>
      </GridContainer>
    </div>
  );
}
